import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { RoomUnreadState } from '../../types';

export const updateRoomUnreadState = createAction(
  `${reduxKey}.UPDATE_ROOM_WINDOW_STATE`,
  (room_id: string, updates: Partial<RoomUnreadState>) => ({
    room_id,
    updates,
  })
);

export const markLastViewedMessage = createAction(
  `${reduxKey}.MARK_LAST_VIEWED_MESSAGE`,
  (room_id: string, messageId: string) => ({
    room_id,
    messageId,
  })
);

export const markLastViewedMessageSuccess = createAction(
  `${reduxKey}.MARK_LAST_VIEWED_MESSAGE_SUCCESS`,
  (room_id: string, messageId: string) => ({
    room_id,
    messageId,
  })
);
